import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhyChooseUs from './components/WhyChooseUs';
import AboutPreview from './components/AboutPreview';
import SeasonalPicks from './components/SeasonalPicks';
import Certifications from './components/Certifications';
import BulkSupplyCTA from './components/BulkSupplyCTA';
import GalleryPreview from './components/GalleryPreview';
import ContactPreview from './components/ContactPreview';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <WhyChooseUs />
        <AboutPreview />
        <SeasonalPicks />
        <Certifications />
        <BulkSupplyCTA />
        <GalleryPreview />
        <ContactPreview />
      </main>
      <Footer />
    </div>
  );
}